import * as React from 'react'
import ReactPixel from 'react-facebook-pixel'
import { useLocation } from 'react-router-dom'

import { Loading } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import { CanSeeModulesMarketplaceDocument } from 'generated/resources/graphql'
import { CanSeeMarketplaceRevampDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import RevampList from 'modules/marketplace_modules/components/Revamp/List'

const ModulesPage = () => {
  const environment = React.useContext(EnvironmentContext)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const { data: policies } = useQuery(CanSeeModulesMarketplaceDocument)
  const isAuthorized = policies?.modules._policies.moduleManageModule.can
  const { data: isRevampEnabled, loading: isRevampEnabledLoading } = useQuery(
    CanSeeMarketplaceRevampDocument
  )
  const isAuthorizedRevamp =
    isRevampEnabled?.modules._policies.marketplaceRevampSeeMarketplaceRevamp.can

  const { facebookPixelEnabled } = environment
  useEffect(() => {
    track(trackingEvents.marketplaceModules.visitModulesPage, {
      upsell_origin: queryParams.get('upsell_origin'),
    })
    facebookPixelEnabled &&
      ReactPixel.trackCustom('ViewAdminOnlyPage', { page: 'MarketplaceModulesPage' })
  }, [facebookPixelEnabled])

  if (isRevampEnabledLoading) {
    return <Loading />
  }

  return (
    <ResponsivePage.Body authorized={isAuthorized || isAuthorizedRevamp}>
      <RevampList />
    </ResponsivePage.Body>
  )
}

export default ModulesPage
